import { exeRequest } from '../utils/APIUtils';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    // Liste toutes les bannières
    getAll: async (filters = {}) => {
        let url = '/admin/banners';
        const params = new URLSearchParams();

        if (filters.position) params.append('position', filters.position);
        if (filters.isActive !== undefined) params.append('isActive', filters.isActive);

        const queryString = params.toString();
        if (queryString) url += `?${queryString}`;

        return exeRequest(url, 'GET');
    },

    // Récupère une bannière par ID
    getById: async (id) => exeRequest(`/admin/banners/${id}`, 'GET'),

    // Crée une nouvelle bannière
    create: async (data) => {
        const formData = new FormData();

        formData.append('title', data.title);
        if (data.subtitle) formData.append('subtitle', data.subtitle);
        if (data.linkUrl) formData.append('linkUrl', data.linkUrl);
        formData.append('position', data.position || 'middle');
        formData.append('order', data.order || 0);
        formData.append('isActive', data.isActive !== false);

        if (data.startDate) formData.append('startDate', data.startDate);
        if (data.endDate) formData.append('endDate', data.endDate);

        // Champs promo (pour position hero)
        formData.append('showPromoBox', data.showPromoBox || false);
        if (data.promoMessage) formData.append('promoMessage', data.promoMessage);
        if (data.promoSubtext) formData.append('promoSubtext', data.promoSubtext);
        if (data.promoBackgroundColor) formData.append('promoBackgroundColor', data.promoBackgroundColor);
        if (data.promoTextColor) formData.append('promoTextColor', data.promoTextColor);

        // Image: peut être un fichier ou une URL
        if (data.image instanceof File) {
            formData.append('image', data.image);
        } else if (data.imageUrl) {
            formData.append('imageUrl', data.imageUrl);
        }

        return exeRequest('/admin/banners', 'POST', formData);
    },

    // Met à jour une bannière
    update: async (id, data) => {
        const formData = new FormData();

        formData.append('title', data.title);
        if (data.subtitle !== undefined) formData.append('subtitle', data.subtitle);
        if (data.linkUrl !== undefined) formData.append('linkUrl', data.linkUrl);
        formData.append('position', data.position || 'middle');
        formData.append('order', data.order || 0);
        formData.append('isActive', data.isActive !== false);

        if (data.startDate) formData.append('startDate', data.startDate);
        if (data.endDate) formData.append('endDate', data.endDate);

        // Champs promo (pour position hero)
        formData.append('showPromoBox', data.showPromoBox || false);
        if (data.promoMessage !== undefined) formData.append('promoMessage', data.promoMessage);
        if (data.promoSubtext !== undefined) formData.append('promoSubtext', data.promoSubtext);
        if (data.promoBackgroundColor) formData.append('promoBackgroundColor', data.promoBackgroundColor);
        if (data.promoTextColor) formData.append('promoTextColor', data.promoTextColor);

        // Image: peut être un fichier ou une URL existante
        if (data.image instanceof File) {
            formData.append('image', data.image);
        } else if (data.imageUrl) {
            formData.append('imageUrl', data.imageUrl);
        }

        return exeRequest(`/admin/banners/${id}`, 'PUT', formData);
    },

    // Supprime une bannière
    delete: async (id) => exeRequest(`/admin/banners/${id}`, 'DELETE'),

    // Active/Désactive une bannière
    toggle: async (id) => exeRequest(`/admin/banners/${id}/toggle`, 'PATCH'),

    // Réorganise l'ordre des bannières
    reorder: async (banners) => exeRequest('/admin/banners/reorder', 'POST', { banners }),
};
